import Vue from 'vue'
import { Popconfirm,TabPane,Tabs,Table, TableColumn, Rate, Select, Option, Upload, Pagination, Message, DatePicker, TimePicker, TimeSelect, Image, Carousel,Collapse, Dialog } from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Rate)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Image)
Vue.use(Carousel)
Vue.use(Collapse)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Popconfirm)
Vue.use(Dialog);

Vue.prototype.$message = Message